import React from "react";
import {Button, Dropdown, MenuProps, Spin} from "antd";
import './login.css';
import {
    ADMIN_DASHBOARD_ROUTE,
    BUY_PLAN_ROUTE,
    LOGIN_ROUTE,
    TEACHER_DASHBOARD_ROUTE,
    USER_DASHBOARD_PROFILE_ROUTE
} from "../../routes/route-path";
import TokenService from "../../services/TokenService";
import {useNavigate} from "react-router-dom";
import {Role, User} from "../../services/UserService";
import {numberWithCommasToman} from "../../services/UtilFunctions";

const color = "#2F80ED";
interface Props {
    profile:User | undefined;
}
export const Login = ({profile} : Props) => {

    const navigate = useNavigate();


    const getItems = () => {
        const list = [
            {
                key: '0.9',
                label: (
                    <a>
                         موجودی کیف پول: {profile ? numberWithCommasToman(profile.walletBalance) : "0"}
                    </a>
                )
            },
            {
                key: '1.0',
                label: (
                    <a href={BUY_PLAN_ROUTE}>
                        خرید اشتراک
                    </a>
                )
            },
            {
                key: '1.1',
                label: (
                    <a>
                        {profile ? profile.firstName + " " + profile.lastName : ""}
                    </a>
                )
            },
            {
                key: '1.2',
                label: (
                    <a>
                        {profile ? "نام کاربری: " + profile.username : ""}
                    </a>
                )
            }
        ];
        if (profile && profile.roles && profile.roles.includes(Role.ROLE_ADMIN)) {
            list.push(
                {
                    key: '2',
                    label: (
                        <a href={ADMIN_DASHBOARD_ROUTE}>
                            داشبورد ادمین
                        </a>
                    ),
                }
            );
        }
        if (profile && profile.roles && profile.roles.includes(Role.ROLE_TEACHER)) {
            list.push(
                {
                    key: '3',
                    label: (
                        <a href={TEACHER_DASHBOARD_ROUTE}>
                            داشبورد مدرس
                        </a>
                    ),
                }
            );
        }
        if (profile && profile.roles && profile.roles.includes(Role.ROLE_USER)) {
            list.push(
                {
                    key: '4',
                    label: (
                        <a href={USER_DASHBOARD_PROFILE_ROUTE}>
                            داشبورد کاربر
                        </a>
                    ),
                }
            );
        }
        list.push({
            key: '5',
            label: (
                <a onClick={event => TokenService.logout()}>
                    خروج
                </a>
            ),
        })
        return list;
    }

    const items: MenuProps['items'] = getItems();

    const loginButton = () => {
        return (
            <Button onClick={event => navigate(LOGIN_ROUTE)} style={{
                borderRadius: "24px",
                color: color,
                borderColor: color,
                width: "163px",
                height: "48px",
                borderWidth: "3px"
            }}>
            <span style={{marginLeft: "10px"}}>
                <svg style={{verticalAlign: "middle"}} width="12" height="14" viewBox="0 0 12 14" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
<path
    d="M9.83599 8.33333C10.0329 8.33324 10.228 8.37196 10.41 8.44727C10.592 8.52258 10.7573 8.63301 10.8966 8.77224C11.0359 8.91148 11.1464 9.07679 11.2218 9.25874C11.2972 9.44069 11.336 9.63571 11.336 9.83267V10.216C11.336 10.812 11.1227 11.3893 10.7347 11.8413C9.68799 13.064 8.09666 13.6673 5.99999 13.6673C3.90266 13.6673 2.31199 13.064 1.26799 11.8407C0.881583 11.3881 0.669306 10.8125 0.669327 10.2173V9.83267C0.669239 9.63571 0.707956 9.44067 0.783265 9.25869C0.858575 9.07671 0.969001 8.91134 1.10824 8.77205C1.24747 8.63275 1.41279 8.52225 1.59474 8.44686C1.77669 8.37147 1.97171 8.33267 2.16866 8.33267H9.83599V8.33333ZM9.83599 9.33333H2.16866C2.10303 9.33324 2.03803 9.3461 1.97737 9.37115C1.91671 9.3962 1.86159 9.43297 1.81515 9.47935C1.76871 9.52572 1.73187 9.5808 1.70673 9.64143C1.6816 9.70205 1.66866 9.76704 1.66866 9.83267V10.2173C1.66866 10.5747 1.79666 10.92 2.02866 11.1913C2.86399 12.17 4.17466 12.6673 5.99999 12.6673C7.82533 12.6673 9.13733 12.17 9.97466 11.1913C10.2073 10.9196 10.3352 10.5737 10.3353 10.216V9.83267C10.3354 9.76704 10.3226 9.70203 10.2975 9.64137C10.2725 9.58072 10.2357 9.52559 10.1893 9.47915C10.1429 9.43271 10.0879 9.39587 10.0272 9.37074C9.96661 9.3456 9.90162 9.33267 9.83599 9.33267V9.33333ZM5.99999 0.335999C6.88405 0.335999 7.73189 0.687188 8.35702 1.31231C8.98214 1.93743 9.33333 2.78528 9.33333 3.66933C9.33333 4.55339 8.98214 5.40123 8.35702 6.02635C7.73189 6.65148 6.88405 7.00267 5.99999 7.00267C5.11594 7.00267 4.26809 6.65148 3.64297 6.02635C3.01785 5.40123 2.66666 4.55339 2.66666 3.66933C2.66666 2.78528 3.01785 1.93743 3.64297 1.31231C4.26809 0.687188 5.11594 0.335999 5.99999 0.335999ZM5.99999 1.336C5.69358 1.336 5.39016 1.39635 5.10707 1.51361C4.82397 1.63087 4.56675 1.80275 4.35008 2.01942C4.13341 2.23609 3.96154 2.49331 3.84427 2.7764C3.72701 3.0595 3.66666 3.36291 3.66666 3.66933C3.66666 3.97575 3.72701 4.27917 3.84427 4.56226C3.96154 4.84535 4.13341 5.10258 4.35008 5.31925C4.56675 5.53592 4.82397 5.70779 5.10707 5.82505C5.39016 5.94231 5.69358 6.00267 5.99999 6.00267C6.61883 6.00267 7.21232 5.75683 7.64991 5.31925C8.08749 4.88166 8.33333 4.28817 8.33333 3.66933C8.33333 3.05049 8.08749 2.457 7.64991 2.01942C7.21232 1.58183 6.61883 1.336 5.99999 1.336Z"
    fill={color}/>
</svg>
            </span>
                <span style={{fontSize: "14px"}}>
                ورود یا ثبت نام
            </span>
            </Button>
        );
    }

    const getProfile = () => {
        return (
            profile ? <Dropdown menu={{items}} placement="bottom">
                <Button style={{
                    borderRadius: "24px",
                    color: color,
                    borderColor: color,
                    width: "163px",
                    height: "48px",
                    borderWidth: "3px"
                }}>
            <span style={{marginLeft: "10px"}}>
                <svg style={{verticalAlign: "middle"}} width="12" height="14" viewBox="0 0 12 14" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
<path
    d="M9.83599 8.33333C10.0329 8.33324 10.228 8.37196 10.41 8.44727C10.592 8.52258 10.7573 8.63301 10.8966 8.77224C11.0359 8.91148 11.1464 9.07679 11.2218 9.25874C11.2972 9.44069 11.336 9.63571 11.336 9.83267V10.216C11.336 10.812 11.1227 11.3893 10.7347 11.8413C9.68799 13.064 8.09666 13.6673 5.99999 13.6673C3.90266 13.6673 2.31199 13.064 1.26799 11.8407C0.881583 11.3881 0.669306 10.8125 0.669327 10.2173V9.83267C0.669239 9.63571 0.707956 9.44067 0.783265 9.25869C0.858575 9.07671 0.969001 8.91134 1.10824 8.77205C1.24747 8.63275 1.41279 8.52225 1.59474 8.44686C1.77669 8.37147 1.97171 8.33267 2.16866 8.33267H9.83599V8.33333ZM9.83599 9.33333H2.16866C2.10303 9.33324 2.03803 9.3461 1.97737 9.37115C1.91671 9.3962 1.86159 9.43297 1.81515 9.47935C1.76871 9.52572 1.73187 9.5808 1.70673 9.64143C1.6816 9.70205 1.66866 9.76704 1.66866 9.83267V10.2173C1.66866 10.5747 1.79666 10.92 2.02866 11.1913C2.86399 12.17 4.17466 12.6673 5.99999 12.6673C7.82533 12.6673 9.13733 12.17 9.97466 11.1913C10.2073 10.9196 10.3352 10.5737 10.3353 10.216V9.83267C10.3354 9.76704 10.3226 9.70203 10.2975 9.64137C10.2725 9.58072 10.2357 9.52559 10.1893 9.47915C10.1429 9.43271 10.0879 9.39587 10.0272 9.37074C9.96661 9.3456 9.90162 9.33267 9.83599 9.33267V9.33333ZM5.99999 0.335999C6.88405 0.335999 7.73189 0.687188 8.35702 1.31231C8.98214 1.93743 9.33333 2.78528 9.33333 3.66933C9.33333 4.55339 8.98214 5.40123 8.35702 6.02635C7.73189 6.65148 6.88405 7.00267 5.99999 7.00267C5.11594 7.00267 4.26809 6.65148 3.64297 6.02635C3.01785 5.40123 2.66666 4.55339 2.66666 3.66933C2.66666 2.78528 3.01785 1.93743 3.64297 1.31231C4.26809 0.687188 5.11594 0.335999 5.99999 0.335999ZM5.99999 1.336C5.69358 1.336 5.39016 1.39635 5.10707 1.51361C4.82397 1.63087 4.56675 1.80275 4.35008 2.01942C4.13341 2.23609 3.96154 2.49331 3.84427 2.7764C3.72701 3.0595 3.66666 3.36291 3.66666 3.66933C3.66666 3.97575 3.72701 4.27917 3.84427 4.56226C3.96154 4.84535 4.13341 5.10258 4.35008 5.31925C4.56675 5.53592 4.82397 5.70779 5.10707 5.82505C5.39016 5.94231 5.69358 6.00267 5.99999 6.00267C6.61883 6.00267 7.21232 5.75683 7.64991 5.31925C8.08749 4.88166 8.33333 4.28817 8.33333 3.66933C8.33333 3.05049 8.08749 2.457 7.64991 2.01942C7.21232 1.58183 6.61883 1.336 5.99999 1.336Z"
    fill={color}/>
</svg>
            </span>
                    <span style={{fontSize: "inherit"}}>

                    <span style={{color: "inherit", fontWeight: "inherit"}}>حساب کاربر</span>

          </span>
                </Button>
            </Dropdown> : <Spin />
        );
    }

    return (
        <span>
            {
                TokenService.isLogin() ? getProfile() : loginButton()
            }
        </span>
    );

}